export interface Product {
  id: string;
  name: string;
  slug: string;
  category: 'Chains & Pendants' | 'Earrings' | 'Matching Sets';
  style: 'Korean Minimal' | 'Multi-Layered' | 'Statement/Bold' | 'Heritage-Modern Fusion' | 'Pearl-Accent' | 'Charm/Personalised' | 'Western Edgy';
  occasion: 'Office Wear' | 'Daily Wear' | 'Campus & Active Wear' | 'Date Night' | 'Festive & Event Wear' | 'Gifting Edits';
  price: number;
  mrp: number;
  isNew: boolean;
  isLimited: boolean;
  isLowStock: boolean;
  isSet: boolean;
  description: string;
  details: string;
  careInstructions: string;
  images: string[];
  variants?: { label: string; options: string[] }[];
}

export const products: Product[] = [
  {
    id: 'aurora-chain-pendant',
    name: 'Aurora Chain Pendant',
    slug: 'aurora-chain-pendant',
    category: 'Chains & Pendants',
    style: 'Korean Minimal',
    occasion: 'Daily Wear',
    price: 899,
    mrp: 1199,
    isNew: true,
    isLimited: false,
    isLowStock: true,
    isSet: false,
    description: 'A delicate 316L stainless steel chain with a tiny coin pendant in PVD 18K gold-tone plating. Designed for the woman who wants her gold to whisper, not shout.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone (0.5 micron) | Chain Length: 18 inches | Pendant: 8mm coin disc | Closure: Lobster clasp',
    careInstructions: 'Avoid chlorinated water and direct perfume contact. Wipe gently with a soft cloth after wearing. Store in the provided anti-tarnish pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Delicate%20gold%20chain%20necklace%20with%20tiny%20coin%20pendant%20on%20warm%20blush%20sand%20background%2C%20minimal%20editorial%20jewellery%20photography%2C%20soft%20golden%20hour%20lighting%2C%20clean%20aesthetic%2C%20premium%20product%20shot&width=800&height=800&seq=aurora-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Closeup%20of%20tiny%20gold%20coin%20pendant%20necklace%20on%20model%20wearing%20white%20linen%2C%20warm%20natural%20light%2C%20soft%20focus%2C%20lifestyle%20editorial%20jewellery%20photography&width=800&height=800&seq=aurora-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20chain%20necklace%20flat%20lay%20on%20cream%20silk%20fabric%2C%20minimal%20composition%2C%20soft%20warm%20lighting%2C%20premium%20product%20photography%20with%20negative%20space&width=800&height=800&seq=aurora-03&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20delicate%20gold%20coin%20necklace%20with%20off%20white%20blouse%2C%20warm%20studio%20light%2C%20editorial%20fashion%20jewellery%20photography%2C%20soft%20golden%20tones&width=800&height=800&seq=aurora-04&orientation=squarish'
    ],
    variants: [
      { label: 'Chain Length', options: ['16 inches', '18 inches', '20 inches'] }
    ]
  },
  {
    id: 'mira-studs',
    name: 'Mira Studs',
    slug: 'mira-studs',
    category: 'Earrings',
    style: 'Korean Minimal',
    occasion: 'Office Wear',
    price: 649,
    mrp: 849,
    isNew: true,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'Petite gold ball studs with a high-polish mirror finish. So lightweight you will forget you are wearing them — but everyone else will notice.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Size: 5mm ball | Backing: Push-back with secure grip | Weight: 0.8g per stud',
    careInstructions: 'Keep away from chlorinated water. Wipe after use with a soft dry cloth. Store in anti-tarnish pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Tiny%20gold%20ball%20stud%20earrings%20on%20blush%20pink%20background%2C%20high%20polish%20mirror%20finish%2C%20minimal%20jewellery%20product%20photography%2C%20soft%20warm%20lighting%2C%20clean%20composition&width=800&height=800&seq=mira-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Closeup%20of%20gold%20ball%20studs%20on%20model%20ear%2C%20warm%20skin%20tone%2C%20soft%20natural%20light%2C%20editorial%20beauty%20jewellery%20photography&width=800&height=800&seq=mira-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20ball%20earrings%20flat%20lay%20on%20cream%20linen%2C%20minimal%20style%2C%20warm%20golden%20hour%20lighting%2C%20premium%20jewellery%20photography&width=800&height=800&seq=mira-03&orientation=squarish'
    ]
  },
  {
    id: 'layla-layered-set',
    name: 'Layla Layered Set',
    slug: 'layla-layered-set',
    category: 'Matching Sets',
    style: 'Multi-Layered',
    occasion: 'Date Night',
    price: 1499,
    mrp: 1999,
    isNew: false,
    isLimited: false,
    isLowStock: true,
    isSet: true,
    description: 'Two chains, one look. A dainty box chain paired with a slightly longer paperclip chain — together they create that effortlessly styled layered look. Set of 2.',
    details: 'Set of 2 Chains | Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Chain 1: 16-inch box chain | Chain 2: 18-inch paperclip chain | Both with lobster clasps',
    careInstructions: 'Avoid chlorinated water. Store separately in anti-tarnish pouch to prevent tangling. Wipe after each wear.',
    images: [
      'https://readdy.ai/api/search-image?query=Layered%20gold%20chain%20necklaces%20box%20chain%20and%20paperclip%20chain%20together%20on%20blush%20sand%20background%2C%20warm%20editorial%20lighting%2C%20premium%20jewellery%20flat%20lay&width=800&height=800&seq=layla-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20two%20layered%20gold%20necklaces%20with%20neutral%20top%2C%20warm%20studio%20light%2C%20soft%20focus%2C%20editorial%20fashion%20jewellery%20photography&width=800&height=800&seq=layla-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Two%20gold%20chains%20layered%20flat%20lay%20on%20cream%20marble%20surface%2C%20minimal%20composition%2C%20warm%20lighting%2C%20premium%20product%20photography&width=800&height=800&seq=layla-03&orientation=squarish'
    ]
  },
  {
    id: 'zara-hoops',
    name: 'Zara Hoops',
    slug: 'zara-hoops',
    category: 'Earrings',
    style: 'Statement/Bold',
    occasion: 'Date Night',
    price: 1099,
    mrp: 1399,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'Medium gold hoops with a subtle hammered texture that catches light beautifully. Bold enough to make a statement, light enough to wear all day.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Diameter: 25mm | Thickness: 3mm | Closure: Hinged click-top | Weight: 4.2g per pair',
    careInstructions: 'Avoid contact with perfumes and chlorinated water. Wipe clean with a soft cloth. Store in pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Medium%20gold%20hoop%20earrings%20with%20hammered%20texture%20on%20warm%20beige%20background%2C%20subtle%20light%20reflections%2C%20premium%20jewellery%20product%20photography&width=800&height=800&seq=zara-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20gold%20hoop%20earrings%20profile%20shot%2C%20warm%20golden%20hour%20light%2C%20editorial%20fashion%20portrait%2C%20soft%20background&width=800&height=800&seq=zara-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20hoop%20earring%20closeup%20showing%20hammered%20texture%20detail%2C%20warm%20lighting%2C%20macro%20jewellery%20photography&width=800&height=800&seq=zara-03&orientation=squarish'
    ]
  },
  {
    id: 'kaira-tennis-chain',
    name: 'Kaira Tennis Chain',
    slug: 'kaira-tennis-chain',
    category: 'Chains & Pendants',
    style: 'Western Edgy',
    occasion: 'Festive & Event Wear',
    price: 1299,
    mrp: 1699,
    isNew: false,
    isLimited: true,
    isLowStock: false,
    isSet: false,
    description: 'Our take on the classic tennis chain — uniform gold-tone links in a sleek continuous row. Dress it up for weddings or down with a tee.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Link Size: 3mm | Length: 18 inches | Closure: Secure box clasp with safety latch',
    careInstructions: 'Avoid chlorinated water and heavy sweat exposure. Wipe after wearing. Store flat in anti-tarnish pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Elegant%20gold%20tennis%20chain%20necklace%20uniform%20links%20on%20soft%20blush%20background%2C%20sparkling%20light%20reflections%2C%20premium%20jewellery%20product%20photography&width=800&height=800&seq=kaira-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20gold%20tennis%20chain%20with%20elegant%20outfit%2C%20warm%20studio%20lighting%2C%20editorial%20fashion%20photography%2C%20luxury%20feel&width=800&height=800&seq=kaira-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20tennis%20chain%20flat%20lay%20detail%20showing%20link%20structure%2C%20warm%20lighting%2C%20macro%20jewellery%20photography%20on%20cream%20surface&width=800&height=800&seq=kaira-03&orientation=squarish'
    ]
  },
  {
    id: 'deepa-jhumkas',
    name: 'Deepa Jhumkas',
    slug: 'deepa-jhumkas',
    category: 'Earrings',
    style: 'Heritage-Modern Fusion',
    occasion: 'Festive & Event Wear',
    price: 1199,
    mrp: 1499,
    isNew: false,
    isLimited: true,
    isLowStock: false,
    isSet: false,
    description: 'A modern take on the classic jhumka. Clean bell silhouette in polished gold-tone with a delicate filigree-inspired texture — heritage meets contemporary.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Drop Length: 35mm | Bell Diameter: 12mm | Closure: Post back with secure push | Weight: 5.8g per pair',
    careInstructions: 'Handle with care. Avoid water contact. Wipe with soft cloth. Store in anti-tarnish pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Modern%20gold%20jhumka%20earrings%20clean%20bell%20shape%20on%20warm%20blush%20background%2C%20filigree%20texture%2C%20premium%20Indian%20fusion%20jewellery%20photography&width=800&height=800&seq=deepa-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20gold%20jhumka%20earrings%20side%20profile%2C%20warm%20golden%20light%2C%20editorial%20Indian%20jewellery%20photography%2C%20elegant&width=800&height=800&seq=deepa-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Closeup%20of%20gold%20jhumka%20earring%20detail%20filigree%20work%2C%20warm%20lighting%2C%20macro%20photography%20on%20cream%20background&width=800&height=800&seq=deepa-03&orientation=squarish'
    ]
  },
  {
    id: 'noor-pendant',
    name: 'Noor Pendant',
    slug: 'noor-pendant',
    category: 'Chains & Pendants',
    style: 'Heritage-Modern Fusion',
    occasion: 'Gifting Edits',
    price: 999,
    mrp: 1299,
    isNew: true,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'A solitaire-style pendant with a single cubic zirconia stone set in a 6-prong gold-tone basket. Understated sparkle for every day.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Stone: Cubic Zirconia (3mm) | Chain: 18-inch cable chain | Closure: Lobster clasp',
    careInstructions: 'Avoid harsh chemicals. Wipe stone with a soft damp cloth. Store in anti-tarnish pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Delicate%20gold%20solitaire%20pendant%20with%20clear%20stone%20on%20blush%20sand%20background%2C%20sparkle%20effect%2C%20premium%20minimal%20jewellery%20photography&width=800&height=800&seq=noor-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20tiny%20gold%20solitaire%20necklace%20closeup%2C%20warm%20natural%20light%2C%20editorial%20jewellery%20photography%2C%20soft%20focus&width=800&height=800&seq=noor-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20solitaire%20pendant%20flat%20lay%20with%20stone%20sparkle%2C%20warm%20lighting%2C%20premium%20product%20photography%20on%20cream%20surface&width=800&height=800&seq=noor-03&orientation=squarish'
    ]
  },
  {
    id: 'sana-chain-bracelet',
    name: 'Sana Chain Bracelet',
    slug: 'sana-chain-bracelet',
    category: 'Chains & Pendants',
    style: 'Korean Minimal',
    occasion: 'Office Wear',
    price: 749,
    mrp: 949,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'A fine cable chain bracelet with an adjustable closure. Wear it solo for a whisper of gold or stack it with your watch.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Chain Width: 1.2mm | Length: Adjustable 6-7.5 inches | Closure: Lobster clasp with extender',
    careInstructions: 'Remove before swimming or showering. Wipe after wear. Store in anti-tarnish pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Thin%20gold%20chain%20bracelet%20on%20blush%20pink%20background%2C%20minimal%20delicate%20jewellery%2C%20warm%20soft%20lighting%2C%20premium%20product%20photography&width=800&height=800&seq=sana-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Wrist%20wearing%20thin%20gold%20chain%20bracelet%20with%20watch%2C%20warm%20natural%20light%2C%20lifestyle%20editorial%20photography&width=800&height=800&seq=sana-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20chain%20bracelet%20flat%20lay%20on%20cream%20linen%2C%20minimal%20composition%2C%20warm%20lighting&width=800&height=800&seq=sana-03&orientation=squarish'
    ]
  },
  {
    id: 'parisa-pearl-drops',
    name: 'Parisa Pearl Drops',
    slug: 'parisa-pearl-drops',
    category: 'Earrings',
    style: 'Pearl-Accent',
    occasion: 'Date Night',
    price: 899,
    mrp: 1149,
    isNew: true,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'Gold-tone drop earrings with a single faux pearl at the tip. Think Audrey Hepburn, but make it 2026.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Accent: Premium faux pearl (6mm) | Drop Length: 28mm | Closure: Post back',
    careInstructions: 'Pearls are delicate — avoid water and perfume. Wipe gently. Store separately in pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Gold%20drop%20earrings%20with%20white%20faux%20pearl%20tip%20on%20warm%20blush%20background%2C%20elegant%20minimal%20jewellery%20photography%2C%20soft%20lighting&width=800&height=800&seq=parisa-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20gold%20pearl%20drop%20earrings%20closeup%2C%20warm%20studio%20light%2C%20editorial%20elegant%20portrait%2C%20soft%20skin%20tones&width=800&height=800&seq=parisa-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20pearl%20earring%20closeup%20detail%2C%20warm%20lighting%2C%20macro%20jewellery%20photography%20on%20cream%20silk&width=800&height=800&seq=parisa-03&orientation=squarish'
    ]
  },
  {
    id: 'riya-personalised-disc',
    name: 'Riya Personalised Disc',
    slug: 'riya-personalised-disc',
    category: 'Chains & Pendants',
    style: 'Charm/Personalised',
    occasion: 'Gifting Edits',
    price: 1099,
    mrp: 1399,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'A polished gold-tone disc pendant engraved with your initial. The gift that says "I thought about you." (Initial selection is visual only.)',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Disc: 12mm | Chain: 18-inch cable chain | Engraving: Single initial letter | Closure: Lobster clasp',
    careInstructions: 'Avoid chlorinated water. Wipe clean with a soft cloth. Store in anti-tarnish pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Gold%20disc%20pendant%20necklace%20with%20engraved%20letter%20on%20warm%20blush%20background%2C%20personalised%20jewellery%2C%20minimal%20editorial%20photography&width=800&height=800&seq=riya-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20gold%20initial%20disc%20necklace%2C%20warm%20natural%20light%2C%20lifestyle%20editorial%20jewellery%20photography%2C%20soft%20portrait&width=800&height=800&seq=riya-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20initial%20pendant%20flat%20lay%20with%20letter%20detail%2C%20warm%20lighting%2C%20premium%20macro%20photography%20on%20cream%20surface&width=800&height=800&seq=riya-03&orientation=squarish'
    ]
  },
  {
    id: 'meera-choker',
    name: 'Meera Choker',
    slug: 'meera-choker',
    category: 'Chains & Pendants',
    style: 'Heritage-Modern Fusion',
    occasion: 'Festive & Event Wear',
    price: 1399,
    mrp: 1799,
    isNew: false,
    isLimited: true,
    isLowStock: true,
    isSet: false,
    description: 'A sleek gold-tone choker with geometric meenakari-inspired accents. Traditional craft codes, reimagined for the modern wardrobe.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Length: 14 inches with 2-inch extender | Width: 4mm | Design: Geometric meenakari-inspired pattern | Closure: Box clasp',
    careInstructions: 'Remove before sleeping or exercising. Avoid water and perfume. Wipe with soft cloth. Store flat.',
    images: [
      'https://readdy.ai/api/search-image?query=Sleek%20gold%20choker%20necklace%20with%20geometric%20Indian%20inspired%20pattern%20on%20warm%20blush%20background%2C%20premium%20fusion%20jewellery%20photography&width=800&height=800&seq=meera-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20gold%20choker%20necklace%20with%20traditional%20outfit%2C%20warm%20festive%20lighting%2C%20editorial%20Indian%20jewellery%20photography&width=800&height=800&seq=meera-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20choker%20flat%20lay%20showing%20geometric%20pattern%20detail%2C%20warm%20lighting%2C%20macro%20jewellery%20photography&width=800&height=800&seq=meera-03&orientation=squarish'
    ]
  },
  {
    id: 'anika-studs-set',
    name: 'Anika Studs Set',
    slug: 'anika-studs-set',
    category: 'Matching Sets',
    style: 'Korean Minimal',
    occasion: 'Gifting Edits',
    price: 1199,
    mrp: 1599,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: true,
    description: 'Three pairs of everyday gold studs: a tiny ball, a small square, and a mini triangle. Mix, match, or stack across multiple piercings. Set of 3 pairs.',
    details: 'Set of 3 Pairs | Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Styles: 4mm ball, 5mm square, 6mm triangle | Backing: Push-back | Weight: Varies per pair',
    careInstructions: 'Remove before swimming. Wipe after wear. Store in provided box with individual slots.',
    images: [
      'https://readdy.ai/api/search-image?query=Set%20of%20three%20pairs%20of%20tiny%20gold%20stud%20earrings%20ball%20square%20triangle%20on%20warm%20blush%20background%2C%20minimal%20gift%20set%20photography&width=800&height=800&seq=anika-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Three%20gold%20stud%20earrings%20displayed%20in%20gift%20box%2C%20warm%20lighting%2C%20premium%20unboxing%20photography%2C%20soft%20aesthetic&width=800&height=800&seq=anika-02&orientation=squarish'
    ]
  },
  {
    id: 'tara-chain-pendant',
    name: 'Tara Chain Pendant',
    slug: 'tara-chain-pendant',
    category: 'Chains & Pendants',
    style: 'Multi-Layered',
    occasion: 'Campus & Active Wear',
    price: 849,
    mrp: 1099,
    isNew: true,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'A lightweight gold-tone pendant on an adjustable chain. Sporty-chic with a subtle shimmer — perfect for campus, coffee runs, and beyond.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Pendant: 10mm abstract shape | Chain Length: Adjustable 16-20 inches | Closure: Lobster clasp',
    careInstructions: 'Sweat-proof but wipe after heavy activity. Avoid chlorinated pools. Store in pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Lightweight%20gold%20pendant%20necklace%20abstract%20shape%20on%20warm%20blush%20background%2C%20casual%20chic%20jewellery%2C%20soft%20natural%20lighting&width=800&height=800&seq=tara-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Young%20woman%20wearing%20gold%20pendant%20casual%20outfit%2C%20campus%20lifestyle%2C%20warm%20sunlight%2C%20editorial%20photography&width=800&height=800&seq=tara-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20abstract%20pendant%20flat%20lay%20on%20cream%20surface%2C%20minimal%20composition%2C%20warm%20lighting&width=800&height=800&seq=tara-03&orientation=squarish'
    ]
  },
  {
    id: 'elara-ear-cuff',
    name: 'Elara Ear Cuff',
    slug: 'elara-ear-cuff',
    category: 'Earrings',
    style: 'Western Edgy',
    occasion: 'Campus & Active Wear',
    price: 699,
    mrp: 899,
    isNew: true,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'A sleek gold-tone ear cuff that wraps around the cartilage. No piercing needed. Edgy, cool, and completely commitment-free.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Style: Open cuff (no piercing needed) | Width: 3mm | Fits: Standard cartilage | Adjustable fit',
    careInstructions: 'Gently adjust to fit. Avoid bending repeatedly. Wipe clean. Store flat in pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Sleek%20gold%20ear%20cuff%20open%20design%20on%20warm%20blush%20background%2C%20edgy%20minimal%20jewellery%2C%20premium%20product%20photography&width=800&height=800&seq=elara-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20ear%20wearing%20gold%20ear%20cuff%20closeup%2C%20warm%20studio%20light%2C%20editorial%20fashion%20jewellery%20photography&width=800&height=800&seq=elara-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20ear%20cuff%20flat%20lay%20with%20minimal%20style%2C%20warm%20lighting%2C%20macro%20jewellery%20photography&width=800&height=800&seq=elara-03&orientation=squarish'
    ]
  },
  {
    id: 'kiara-pearl-chain',
    name: 'Kiara Pearl Chain',
    slug: 'kiara-pearl-chain',
    category: 'Chains & Pendants',
    style: 'Pearl-Accent',
    occasion: 'Office Wear',
    price: 949,
    mrp: 1199,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'A fine gold-tone chain interspersed with tiny faux pearls at regular intervals. Elegant enough for the boardroom, subtle enough for brunch.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Accent: 3mm faux pearls at 2cm intervals | Length: 18 inches | Closure: Lobster clasp',
    careInstructions: 'Pearls are delicate. Avoid water and perfume. Wipe gently after each wear. Store in pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Fine%20gold%20chain%20with%20tiny%20white%20pearls%20interspersed%20on%20warm%20blush%20background%2C%20elegant%20minimal%20jewellery%20photography&width=800&height=800&seq=kiara-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20gold%20pearl%20chain%20necklace%20with%20office%20outfit%2C%20warm%20natural%20light%2C%20lifestyle%20editorial%20photography&width=800&height=800&seq=kiara-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20pearl%20chain%20flat%20lay%20detail%2C%20warm%20lighting%2C%20macro%20photography%20on%20cream%20silk&width=800&height=800&seq=kiara-03&orientation=squarish'
    ]
  },
  {
    id: 'reya-statement-ring',
    name: 'Reya Statement Ring',
    slug: 'reya-statement-ring',
    category: 'Chains & Pendants',
    style: 'Statement/Bold',
    occasion: 'Festive & Event Wear',
    price: 799,
    mrp: 999,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'A sculptural gold-tone ring with an organic wave design. Stack it or let it stand alone — either way, it commands attention.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Design: Organic wave sculptural shape | Size: Adjustable open band | Width: 8mm at widest point',
    careInstructions: 'Remove before hand-washing. Avoid perfumes and lotions. Wipe clean. Store in pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Sculptural%20gold%20ring%20organic%20wave%20design%20on%20warm%20blush%20background%2C%20statement%20jewellery%2C%20premium%20product%20photography&width=800&height=800&seq=reya-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Hand%20wearing%20sculptural%20gold%20ring%2C%20warm%20natural%20light%2C%20editorial%20fashion%20photography%2C%20elegant%20fingers&width=800&height=800&seq=reya-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20wave%20ring%20flat%20lay%20detail%2C%20warm%20lighting%2C%20macro%20jewellery%20photography%20on%20cream%20surface&width=800&height=800&seq=reya-03&orientation=squarish'
    ]
  },
  {
    id: 'isha-charm-bracelet',
    name: 'Isha Charm Bracelet',
    slug: 'isha-charm-bracelet',
    category: 'Chains & Pendants',
    style: 'Charm/Personalised',
    occasion: 'Daily Wear',
    price: 849,
    mrp: 1099,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'A dainty gold-tone chain bracelet with a removable sun charm. Wear it with or without the charm — two looks, one bracelet.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Chain: 1.5mm cable chain | Charm: 8mm sun disc (removable) | Length: Adjustable 6-7.5 inches | Closure: Lobster clasp',
    careInstructions: 'Remove charm carefully when swapping. Avoid water. Wipe after wear. Store in pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Dainty%20gold%20chain%20bracelet%20with%20sun%20charm%20on%20warm%20blush%20background%2C%20minimal%20charm%20jewellery%2C%20premium%20product%20photography&width=800&height=800&seq=isha-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Wrist%20wearing%20gold%20charm%20bracelet%20sun%20motif%2C%20warm%20natural%20light%2C%20lifestyle%20editorial%20photography&width=800&height=800&seq=isha-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Gold%20sun%20charm%20bracelet%20flat%20lay%2C%20warm%20lighting%2C%20minimal%20composition%20on%20cream%20surface&width=800&height=800&seq=isha-03&orientation=squarish'
    ]
  },
  {
    id: 'adira-earrings-set',
    name: 'Adira Earrings Set',
    slug: 'adira-earrings-set',
    category: 'Matching Sets',
    style: 'Multi-Layered',
    occasion: 'Gifting Edits',
    price: 1799,
    mrp: 2399,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: true,
    description: 'The ultimate ear stack in a box. A pair of gold studs, a pair of mini hoops, and a pair of drop earrings — curated to mix and match. Set of 3 pairs.',
    details: 'Set of 3 Pairs | Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone | Includes: 4mm studs, 12mm mini hoops, 20mm drop earrings | Backing: Push-back | Gift box included',
    careInstructions: 'Store in the provided box. Avoid water. Wipe after each wear. Each pair has a dedicated slot.',
    images: [
      'https://readdy.ai/api/search-image?query=Curated%20set%20of%20three%20gold%20earring%20pairs%20studs%20hoops%20drops%20in%20gift%20box%2C%20warm%20lighting%2C%20premium%20unboxing%20photography&width=800&height=800&seq=adira-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Three%20gold%20earring%20styles%20displayed%20on%20warm%20blush%20background%2C%20ear%20stack%20inspiration%2C%20premium%20jewellery%20photography&width=800&height=800&seq=adira-02&orientation=squarish'
    ]
  },
  {
    id: 'nysa-drop-earrings',
    name: 'Nysa Drop Earrings',
    slug: 'nysa-drop-earrings',
    category: 'Earrings',
    style: 'Western Edgy',
    occasion: 'Date Night',
    price: 949,
    mrp: 1199,
    isNew: false,
    isLimited: false,
    isLowStock: false,
    isSet: false,
    description: 'Long linear gold-tone drop earrings with a brushed matte finish. Sleek, modern, and quietly dramatic.',
    details: 'Base Metal: 316L Stainless Steel | Plating: PVD 18K Gold-Tone (brushed matte) | Drop Length: 45mm | Width: 2mm | Closure: Post back',
    careInstructions: 'Avoid water and heavy perfume. The matte finish is delicate — wipe gently. Store in pouch.',
    images: [
      'https://readdy.ai/api/search-image?query=Long%20linear%20gold%20drop%20earrings%20brushed%20matte%20finish%20on%20warm%20blush%20background%2C%20modern%20minimal%20jewellery%20photography&width=800&height=800&seq=nysa-01&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Model%20wearing%20long%20gold%20drop%20earrings%20evening%20look%2C%20warm%20studio%20light%2C%20editorial%20fashion%20portrait&width=800&height=800&seq=nysa-02&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Long%20gold%20earring%20flat%20lay%20matte%20finish%20detail%2C%20warm%20lighting%2C%20macro%20photography&width=800&height=800&seq=nysa-03&orientation=squarish'
    ]
  }
];